import React from 'react';

const Resources = () => (
  <section id="resources" className="container my-5">
    <div className="card shadow-sm p-4">
      <h2 className="mb-3">Resources</h2>
      <p>Find curated resources, tutorials, and tools to help you learn and grow as a full stack developer. We regularly update our recommendations to keep you on the cutting edge.</p>
    </div>
  </section>
);

export default Resources; 